import { Id, Identifiable, OrganizationalUnit } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function unassignResourcesFromOrganizationalUnit(httpClient: HttpClient) {
  return (
    organizationalUnit: Identifiable<OrganizationalUnit>,
    resourceUuids: Id[],
  ) =>
    httpClient.sendHttpRequest<Id[]>({
      endpoint: `/organizational-units/${organizationalUnit.uuid}/resources/batch-removal`,
      method: HttpMethods.POST,
      data: resourceUuids,
    });
}

export { unassignResourcesFromOrganizationalUnit };
